import {Link} from "react-router-dom";

export default function Breadcrumb({list}) {
    return (
        <section className="px-4 py-8 bg-gray-100">
            <div className="container mx-auto">
                <ul className="breadcrumb">
                    {
                        list?.map?.((item, index) => {
                            const arias = index === list?.length ? {"aria-label": "current-page"} : {}
                            return (
                                <li key={item.url}>
                                    <Link to={item.url} {...arias}>{item.name}</Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </section>
    )
}